import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ToastController,
  LoadingController,
} from "ionic-angular";
import { EcoEnelEmpresasProvider } from "../../providers/ecoenel-empresas/ecoenel-empresas.provider";
import { ReciclagemCriarPage } from "./reciclagem-criar/reciclagem-criar";
import { ReciclagemDetalhePage } from "./reciclagem-detalhe/reciclagem-detalhe";
import { ReciclagemResponderPage } from "./reciclagem-responder/reciclagem-responder";

/**
 * Pagina principal do modulo EcoEnel Empresas > Reciclagens
 * Exibe lista de reciclagens baseada no perfil do usuario
 *
 * - GRANDE GERADOR: ve suas reciclagens enviadas, pode criar novas
 * - RECICLADOR: ve reciclagens pendentes para aprovar/recusar
 * - ADMIN/GERENTE/DIRETORIA: ve todas as reciclagens
 *
 * Nota: OPERADOR RECICLAGEM e SUPERVISOR RECICLAGEM usam o fluxo padrao (HomePage)
 */
@IonicPage({
  name: "page-ecoenel-empresas",
  segment: "page-ecoenel-empresas",
})
@Component({
  selector: "page-ecoenel-empresas",
  templateUrl: "ecoenel-empresas.html",
})
export class EcoEnelEmpresasPage {
  lancamentos: any[] = [];
  statusList: any[] = [];
  statusSelecionado: number = null;
  perfil: string = "";
  loading: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public provider: EcoEnelEmpresasProvider,
    public loadCtrl: LoadingController,
    public toastCtrl: ToastController
  ) {
    this.getPerfil();
    this.carregarStatus();
  }

  ionViewDidEnter() {
    this.carregarLancamentos();
  }

  getPerfil() {
    const user = JSON.parse(localStorage.getItem("currentUser") || "{}");
    this.perfil = user.perfil && user.perfil.nome ? user.perfil.nome : "";
    console.log('getPerfil - usuario:', user.nome, 'perfil:', this.perfil);
  }

  isGrandeGerador(): boolean {
    return this.perfil === "GRANDE GERADOR";
  }

  isReciclador(): boolean {
    return this.perfil === "RECICLADOR";
  }

  isAdmin(): boolean {
    return ["ADMINISTRADOR", "GERENTE", "DIRETORIA"].indexOf(this.perfil) !== -1;
  }

  carregarStatus() {
    this.provider.getStatus().subscribe(
      (data) => {
        this.statusList = data || [];
      },
      (err) => {
        console.error("Erro ao carregar status", err);
      }
    );
  }

  buildFiltros(): any {
    var filtros: any = {};
    if (this.statusSelecionado) {
      filtros.status_id = this.statusSelecionado;
    }
    return filtros;
  }

  carregarLancamentos() {
    this.loading = true;
    var filtros = this.buildFiltros();

    if (this.isGrandeGerador()) {
      this.provider.getMeusLancamentos(filtros).subscribe(
        (data) => {
          this.lancamentos = data || [];
          this.loading = false;
        },
        (err) => {
          this.showToast("Erro ao carregar reciclagens");
          this.loading = false;
        }
      );
    } else if (this.isReciclador()) {
      this.provider.getLancamentosReciclador(filtros).subscribe(
        (data) => {
          this.lancamentos = data || [];
          this.loading = false;
        },
        (err) => {
          this.showToast("Erro ao carregar reciclagens");
          this.loading = false;
        }
      );
    } else if (this.isAdmin()) {
      this.provider.getTodosLancamentos(filtros).subscribe(
        (data) => {
          this.lancamentos = data || [];
          this.loading = false;
        },
        (err) => {
          this.showToast("Erro ao carregar reciclagens");
          this.loading = false;
        }
      );
    } else {
      this.provider.getMeusLancamentos(filtros).subscribe(
        (data) => {
          this.lancamentos = data || [];
          this.loading = false;
        },
        (err) => {
          this.showToast("Erro ao carregar reciclagens");
          this.loading = false;
        }
      );
    }
  }

  onStatusChange() {
    this.carregarLancamentos();
  }

  novaReciclagem() {
    this.navCtrl.push(ReciclagemCriarPage);
  }

  verDetalhes(lancamento: any) {
    var statusCodigo = lancamento.status ? lancamento.status.codigo : "";

    // Se for reciclador e status submetida ou em validacao, vai para tela de responder
    if (this.isReciclador() && (statusCodigo === "S" || statusCodigo === "V")) {
      this.navCtrl.push(ReciclagemResponderPage, { id: lancamento.id });
    } else {
      this.navCtrl.push(ReciclagemDetalhePage, { id: lancamento.id });
    }
  }

  getStatusColor(status: any): string {
    if (!status) return "primary";

    const colors = {
      S: "warning", // Submetida
      R: "success", // Recebida (aprovada)
      X: "danger", // Cancelada (recusada)
      E: "medium", // Expirada
    };
    return colors[status.codigo] || "primary";
  }

  getStatusLabel(status: any): string {
    if (!status) return "";
    return status.nome || status.codigo;
  }

  showToast(msg: string) {
    this.toastCtrl.create({ message: msg, duration: 3000 }).present();
  }

  doRefresh(refresher: any) {
    this.carregarLancamentos();
    setTimeout(() => refresher.complete(), 1000);
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("pt-BR");
  }

  formatCurrency(value: number): string {
    if (!value) return "R$ 0,00";
    return "R$ " + value.toFixed(2).replace(".", ",");
  }
}



// WEBPACK FOOTER //
// ./src/pages/ecoenel-empresas/ecoenel-empresas.ts